




























import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import moment from "moment";
import { InvestmentTransfer } from "@/shared/types";

import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import ReimbursedExpenseChildRow from "@/shared/components/expense/ReimbursedExpenseChildRow.vue";

@Component({
  components: {
    Pill,
    CurrencyAmount,
    ReimbursedExpenseChildRow
  }
})
export default class InvestmentHistoryRow extends Vue {

  @Prop()
  transfer: InvestmentTransfer;

  get isToInvestmentAccount () {
    return this.transfer.transferType === "toInvestment";
  }

  get pillType () {
    if (this.transfer.status === "processing" || this.transfer.status === "pending") {
      return "neutral-pill";
    }

    return this.transfer.status === "rejected" ? "error-pill" : "";
  }

  get formattedDate (): string {
    return moment(this.transfer.dateCreated).format("MMM D, YYYY");
  }

  get subTitle () {
    return `Transfer ${this.isToInvestmentAccount ? "to" : "from"} TD Ameritrade`;
  }
}
